import { PublicClientApplication } from '@azure/msal-browser'

let clientId
let scopes
let authority
let redirectUri
let preferred_userName = localStorage.getItem('userName');

if (window.location.hostname === "bpm.accenture.com") {
    clientId = '66d5c85c-0a7a-42ea-9a74-784518b6daeb'
    scopes = 'user.read'
    authority = 'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb'
    redirectUri = window.location.origin + '/'
}
// else if (window.location.hostname === "bpminnovation.accenture.com") {
//     clientId = 'df940706-631d-475a-8439-01d89980590f'
//     scopes = 'user.read'
//     authority = 'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb'
//     redirectUri = window.location.origin + '/'
// }

export const GRAPH_REQUESTS = {
    LOGIN: {
        scopes: [scopes],
        login_hint: preferred_userName,
    },
}

export const msalConfig = {
    auth: {
        clientId,
        authority,
        redirectUri,
        validateAuthority: true,
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: 'sessionStorage'
    },
}